module.exports = __webpack_public_path__ + "img/5180ea3.jpg";